<template>
  <b-modal
    title="Apagar endereço"
    no-close-on-backdrop
    size="lg"
    hide-footer
    centered
    header-bg-variant="orange"
    header-text-variant="light"
    v-model="open"
    :busy="loading"
  >
    <b-row>
     <b-col cols="12" class="mt-3">
      <h3 class="text-center mb-4">Deseja realmente apagar o endereço?</h3>
     </b-col>

     <b-col cols="12" class="mt-4 mb-2">
      <div class="d-flex justify-content-center">
        <b-button
          variant="warning"
          @click="open = false"
          class="mr-5"
        >
          Cancelar
        </b-button>
        <b-button
          variant="danger"
          @click="deleteAddress()"
        >
          Excluir
        </b-button>
      </div>
     </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import { mapActions } from 'vuex';
import makeToast from '@/mixins/makeToast';
import UserTypes from '@/enums/UserTypes';

export default {
name: 'DeleteAddressAdditional',
mixins: [makeToast],
emits: ['getAddress'],

data() {
  return {
    loading: false,
    open: false,
    idAddress: "",
    idUser: "",
  };
},

methods: {
  ...mapActions('shopkeeper', ['deleteAddressAdditional', 'deleteAddressAdditionalByClerk']),

  toggleOpen({idAddress = "", idUser = ""}) {
    this.open = !this.open;
    this.idAddress = idAddress
    this.idUser = idUser;
  },

  isValid() {

  },
  deleteAddress() {
    const data = {
      id: this.idAddress,
      usuario_id: this.idUser
    }

    this.$store.dispatch('startLoader');
    this.loading = true;

    const deleteAddressAdditionalShopkeeper = this.$route.meta.userType  == UserTypes.BALCONISTA ?
      this.deleteAddressAdditionalByClerk(data) : 
      this.deleteAddressAdditional(data);
    
      deleteAddressAdditionalShopkeeper.then(() => {
        this.makeToast(
          'Sucesso',
          'Endereço apagado com sucesso',
          'success'
        );
        this.open = !this.open;
        this.$emit('getAddress')
      })
      .catch(() => {
        this.makeToast(
          'Erro',
          'Houve um erro ao deletar o endereço',
          'danger'
        );
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
        this.loading = false;
      });
    },
  },
};
</script>
<style></style>
